<div #container class="form-submission-chart__container"></div>
